"use client"

import ServiceFormApply from "@/(admin)/modules/ui-builder/config/themes/tamda-one/ServiceSidebar/components/ServiceFormApply"
import { ServiceDetailProps } from "@/types/types"

const ServiceDetail: React.FC<ServiceDetailProps> = ({ data, locale, phoneNumber }) => {
  if (!data) return null

  return (
    <div className="mt-5 sm:mt-6 grid grid-cols-1 sm:grid-cols-12 bg-[#f5f5f5] p-5 sm:p-10">
      <div className="sm:px-[0.9375rem] detail sm:col-span-6">
        <div className="prose max-w-none" dangerouslySetInnerHTML={{ __html: data.attributes?.detail || "" }} />
      </div>

      <div className="px-[0.9375rem] pr-0 mt-10 sm:mt-0 sm:col-span-6">
        <ServiceFormApply jobDetail={data} locale={locale} phoneNumber={phoneNumber} />
      </div>
    </div>
  )
}

export default ServiceDetail
